// import React from "react";
// import Topbar from "../Topbar";
// import { MyProSidebarProvider } from "./SidebarContext";
// const LayoutWithSidebarTopbar = ({ component, onLogout }) => {
//   return (
//     <MyProSidebarProvider>
//       <div style={{ display: "flex", height: "100vh", width: "100%" }}>
//         <div style={{ flexGrow: 1, overflow: "auto" }}>
//           <Topbar onLogout={onLogout} />
//           <div style={{ padding: "20px" }}>{component}</div>
//         </div>
//       </div>
//     </MyProSidebarProvider>
//   );
// };

// export default LayoutWithSidebarTopbar;
// In your LayoutWithSidebarTopbar component, add this change:
import React from "react";
import Topbar from "../Topbar";
import { MyProSidebarProvider } from "./SidebarContext";
import ChatWidget from "../../../components/ChatWidget";

const LayoutWithSidebarTopbar = ({ component, onLogout }) => {
  return (
    <MyProSidebarProvider>
      <div className="flex flex-col h-screen w-full overflow-hidden">
        <Topbar onLogout={onLogout} />
        <div className="flex-grow overflow-auto relative">
          <div className="p-5">{component}</div>
        </div>
      </div>
      <ChatWidget />
    </MyProSidebarProvider>
  );
};

export default LayoutWithSidebarTopbar;
